import { FILTERS, ORDERED_SEO_FRIENDLY_FACET_FILTERS } from '@libs/algolia';

export const SEO_FACET_URL_NAMES = new Set(
    Object.values(ORDERED_SEO_FRIENDLY_FACET_FILTERS).map(urlName => urlName.toLowerCase())
);

export const SCHEDULED_DELIVERY_URL_KEY =
    ORDERED_SEO_FRIENDLY_FACET_FILTERS[FILTERS.SCHEDULED_DELIVERY_ELIGIBLE.ATTRIBUTE].toLowerCase();
